// extracted by mini-css-extract-plugin
export default {"formSection":"formSection_formSection__HXAqQ","alignRight":"formSection_alignRight__OH4l2"};